import { platform, PlatformType } from "../../bud-lite-tv/src/lib";

class TizenManager {
  launchAppFTV() {
    tizen?.application.launch(
      "QY16tZ64E3.francetv",
      () => {
        Log.app.log("Launch Success");
      },
      (error: unknown) => {
        Log.app.error("Launch Error: ", JSON.stringify(error));
      }
    );
  }
  private static _instance?: TizenManager;

  static get instance() {
    if (platform.type === PlatformType.tizen) {
      return (TizenManager._instance = TizenManager._instance ?? new TizenManager());
    } else {
      return undefined;
    }
  }
}

export const TizenHelper = TizenManager.instance;
